import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

const App = () => (
    <div className="sid-verification-form">
        <div className="sid-logo sid-l-horz-center">
            <img
                className="sid-logo__img"
                alt="Logo"
                src="https://assets-resources.sheerid.com/simple/5cc73148dc304d16a27de3b5/images/logo-1712089204818.png"
            />
        </div>
        <VerificationForm programId={programId} />
    </div>
);

export default App;
